module.exports = __webpack_public_path__ + "img/cake.5cd9c297.png";